import React from "react";
import s from "../TechSpec.module.scss";

const Table = ({ children }) => <table className={s.table}>{children}</table>;

export default Table;
